import { EnumMobile } from './mobile';
import { EnumOther } from './other';

export const link = {
  ...EnumOther,
  ...EnumMobile,
  /** 登录 */
  account: '/account/',
};
